import {useIntl} from 'react-intl';
import './supportFooter.less';

export default function SupportFooter() {
    const intl = useIntl();

    return (
        <div className="support-footer">
            <p className="support-title">
                {intl.formatMessage({id: 'page.login.need_support_short', defaultMessage: 'Need support?'})}
            </p>
            <div className="support-links">
                <a
                    href={intl.formatMessage({id: 'page.login.portalLink', defaultMessage: ''})}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label={intl.formatMessage({id: 'shared.learnMore', defaultMessage: ''})}
                >
                    {intl.formatMessage({id: 'page.login.help_center', defaultMessage: 'Help Center'})}
                </a>
                <span className="support-sep">·</span>
                <a
                    href={`mailto:${intl.formatMessage({id: 'page.login.emailLink', defaultMessage: ''})}`}
                    aria-label={intl.formatMessage({id: 'esl.generic.email', defaultMessage: ''})}
                >
                    {intl.formatMessage({id: 'page.login.emailLink', defaultMessage: ''})}
                </a>
            </div>
        </div>
    );
}
